module.exports = __webpack_public_path__ + "static/media/acaju.3ee738fd.png";